import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { faker } from "@faker-js/faker";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

const LineChart = ({ totalWeekEachAmount }) => {
  const labels = ['월', '화', '수', '목', '금', '토', '일'];

  // totalWeekEachAmount에서 매출(salesTotal) 값만 추출하여 숫자 배열을 생성
  const salesData = totalWeekEachAmount && totalWeekEachAmount.map(item => item.salesTotal);

  const data = {
    labels,
    datasets: [
      {
        label: '이번 주간 일별 매출(단위 : 원)',

        data: salesData, // 이번 주간 일별 매출 데이터 사용

        borderColor: '#901090',
        backgroundColor: '#a424a4',
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false, // 범례 숨김
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || ''; // 데이터셋의 라벨 가져오기
            if (label) {
              label += ': '; // 라벨과 데이터 사이에 콜론 추가
            }
            if (context.dataset.data !== null) {
              let value = context.dataset.data[context.dataIndex];
              label += value.toLocaleString() + '원'; // 숫자 포맷팅 후 '원' 추가
            }
            return label;
          }
        }
      }
    }
  };

  return <Line data={data} options={options} />;
};

export default LineChart;